export default __webpack_public_path__ + "7edfc9a521ab9d69145661f42a0bf6a9.svg";